import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';
import SharedNavbar from '@/components/feature/SharedNavbar';
import SharedFooter from '@/components/feature/SharedFooter';
import { useSiteDesign } from '@/hooks/useSiteDesign';
import PartnerSuccessV2 from '../v2/PartnerSuccessV2';

export default function PartnerApplySuccessPage() {
  const { isNew } = useSiteDesign();
  return isNew ? <PartnerSuccessV2 /> : <ClassicPartnerApplySuccessPage />;
}

function ClassicPartnerApplySuccessPage() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';

  return (
    <>
      <SharedNavbar />
      <main className="w-full min-h-screen bg-white font-sans flex items-center justify-center pt-24 pb-20">
        <div className="max-w-lg mx-auto px-6 text-center flex flex-col items-center gap-6">
          <div className="w-16 h-16 rounded-full bg-[#2D6A4F]/10 flex items-center justify-center">
            <i className="ri-check-line text-2xl text-[#2D6A4F]"></i>
          </div>

          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2A2A2A]">
            {t('partnerApply.success.title')}
          </h1>

          <p className="text-sm text-[#8A8A8A] font-light leading-relaxed">
            {t('partnerApply.success.body')}
          </p>

          <Link
            to={prefix + '/stores'}
            className="w-full sm:w-auto px-8 py-3.5 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer text-center"
          >
            {t('partnerApply.success.back')}
          </Link>
        </div>
      </main>
      <SharedFooter />
    </>
  );
}